module.exports = __webpack_public_path__ + "static/media/arrow_next.c1da516d.png";